import React from "react";
import Hero from "../components/Hero";
import ServicesSection from "../components/ServicesSection";
import PartnersSection from "../components/PartnersSection";
import MasteryZonesSection from "../components/MasteryZonesSection";
import VisionSection from "../components/VisionSection";
import PhilosophySection from "../components/PhilosophySection";
import TeamSection from "../components/TeamSection";

const Home = () => {
  return (
    <main id="main-content">
      <Hero />
      <ServicesSection />
      <PartnersSection />
      <MasteryZonesSection />
      <VisionSection />
      <PhilosophySection />
      <TeamSection />
    </main>
  );
};

export default Home;
